/**
 * page : 회사연혁
 */
import React from "react";
import '../assets/css/timeline.css';
import * as zy from '../common/zeroyear-1.0.0';
import { MDBCol, MDBContainer, MDBRow } from "mdb-react-ui-kit";
import { useEffect } from "react";
import { useState } from "react";
import Form from 'react-bootstrap/Form';
import Stack from 'react-bootstrap/Stack';
import Card from 'react-bootstrap/Card';
import Swal from "sweetalert2";
let sessionStorage = window.sessionStorage;

// const dataObject = {ESTMTE_DV: '10', ESTMTE_REG_NM: '', ESTMTE_PW: '', ESTMTE_TITLE: ''};
export default function HistoryPage () {
    const [admin, setAdmin] = useState(false);
    const [loading, setLoading] = useState(true);
    const [lrgList, setLrgList] = useState([]); // 대분류
    const [midList, setMidList] = useState([]); // 중분류
    const [srtList, setSrtList] = useState([]); // 소분류
    const [lrgEditList, setLrgEditList] = useState([]); // 대분류
    const [midEditList, setMidEditList] = useState([]); // 중분류
    const [srtEditList, setSrtEditList] = useState([]); // 소분류
    const [editMode, setEditMode] = useState(false);
    /**
     * 연혁 대분류/중분류/소분류 조회
     */
    const selectAll = () => {
        zy.select('selectHisLrgAll', [],(itemLrg) => {
            setLrgList(itemLrg);
            setLrgEditList(itemLrg);
            zy.select('selectHisMidAll', [],(itemMid) => {
                setMidList(itemMid);
                setMidEditList(itemMid);
                zy.select('selectHisSrtAll', [],(itemSrt) => {
                    setSrtList(itemSrt);
                    setSrtEditList(itemSrt);
                    setLoading(false);
                });
            });
        });
    };
    const onEditMode = () => { setEditMode(true); }
    const offEditMode = () => {
        setEditMode(false);
        setLrgEditList(lrgList);
        setMidEditList(midList);
        setSrtEditList(srtList);
    }
    useEffect(() => {
        selectAll();
        setAdmin(sessionStorage.getItem('isLogin'));
    }, []);
    // 대분류 수정
    const changeLrgNm  = (event) => {
        let no = event.target.id.split('_')[1];
        lrgEditList.find(o => o.HIS_LRG_SEQ == no).HIS_LRG_NM = event.target.value;
        setLrgEditList(lrgEditList);
    }
    // 중분류 수정
    const changeMidNm  = (event) => {
        let no = event.target.id.split('_')[1];
        midEditList.find(o => o.HIS_MID_NO == no).HIS_MID_NM = event.target.value;
        setMidEditList(midEditList);
    }
    // 소분류 수정
    const changeShrtNm  = (event) => {
        let no = event.target.id.split('_')[1];
        srtEditList.find(o => o.HIS_SRT_NO == no).HIS_SRT_NM = event.target.value;
        setSrtEditList(srtEditList);
    }
    // 연혁 저장
    const saveHistory = () => {
        /**
        lrgEditList.forEach((item) => {
            zy.modify('updateHisLrg', [item.HIS_LRG_NM, item.HIS_LRG_SEQ], () => {
            });
        });
        midEditList.forEach((item) => {
            zy.modify('updateHisMid', [item.HIS_MID_NM, item.HIS_MID_NO], () => {
            });
        });
        srtEditList.forEach((item) => {
            zy.modify('updateHisSrt', [item.HIS_SRT_NM, item.HIS_SRT_NO], () => {
    
            });
        });
        /**/
        zy.destroy('deleteLrg', [], () => { zy.destroy('deleteMid', [], () => { zy.destroy('deleteSrt', [], () => {
            // 대분류 저장
            lrgEditList.forEach((lrg, lIndex)=> {
                zy.create('insertLrg', [lIndex+1, lrg.HIS_LRG_NM], () => {
                    if (lIndex+1 === lrgEditList.length) {
                        // 중분류 저장
                        midEditList.forEach((mid, mIndex) => {
                            zy.create('insertMid', [mid.HIS_LRG_SEQ, mid.HIS_MID_SEQ, mid.HIS_MID_NM], () => {
                                if (mIndex+1 === midEditList.length) {
    
                                    // 소분류 저장
                                    srtEditList.forEach((srt, sIndex) => {
                                        zy.create('insertSrt', [srt.HIS_LRG_SEQ, srt.HIS_MID_SEQ, srt.HIS_SRT_SEQ, srt.HIS_SRT_NM], () => {
                                            if (sIndex+1 === srtEditList.length) {
                                                Swal.fire({
                                                    icon: "success",
                                                    text: "저장 완료",
                                                }).then((res) => {
                                                    if (res.isConfirmed) { selectAll(); }
                                                    else{ }
                                                });
                                                
                                            }
                                        })
                                    });
    
                                }
                            });
                        });
    
                    }
                });
            });
        });});});
    }
    // appendMid : 대분류 추가
    const appendLrg = (event) => {
        let seq = Number(event.target.dataset.seq)+1;
        let lrg = { HIS_LRG_SEQ: seq, HIS_LRG_NM: '', HIS_LRG_NO: lrgEditList.length+1 };
        let mid = { HIS_LRG_SEQ: seq, HIS_MID_SEQ: 1, HIS_MID_NM: '', HIS_MID_NO: midEditList.length+1 };
        let srt = { HIS_LRG_SEQ: seq, HIS_MID_SEQ: 1, HIS_SRT_NM: '', HIS_SRT_SEQ: 1, HIS_SRT_NO: srtEditList.length+1 };
        setLrgEditList([...lrgEditList, lrg]);
        setMidEditList([...midEditList, mid]);
        setSrtEditList([...srtEditList, srt]);
    };
    // appendMid : 중분류 추가
    const appendMid = (event) => {
        let lrg = Number(event.target.dataset.lrg);
        let mid = { HIS_LRG_SEQ: lrg, HIS_MID_SEQ: Number(event.target.dataset.seq)+1, HIS_MID_NM: '', HIS_MID_NO: midEditList.length+1 };
        let srt = { HIS_LRG_SEQ: lrg, HIS_MID_SEQ: Number(event.target.dataset.seq)+1, HIS_SRT_NM: '', HIS_SRT_SEQ: 1, HIS_SRT_NO: srtEditList.length+1 };
        setSrtEditList([...srtEditList, srt]);
        setMidEditList([...midEditList, mid]);
    };
    // appendShrot : 소분류 추가
    const appendShrot = (event) => {
        let lrg = Number(event.target.dataset.lrg);
        let mid = Number(event.target.dataset.mid);
        let srt = { HIS_LRG_SEQ: lrg, HIS_MID_SEQ: mid, HIS_SRT_SEQ: Number(event.target.dataset.seq)+1, HIS_SRT_NM: '', HIS_SRT_NO: srtEditList.length+1 };
        setSrtEditList([...srtEditList, srt]);
    };
    // 대분류 삭제
    const removeLrg = (event) => {
        setLrgEditList(lrgEditList.filter((item) => item.HIS_LRG_SEQ != Number(event.target.dataset.seq)));
        setMidEditList(midEditList.filter((item) => item.HIS_LRG_SEQ != Number(event.target.dataset.seq)))
        setSrtEditList(srtEditList.filter((item) => item.HIS_LRG_SEQ != Number(event.target.dataset.seq)));
    }
    // 중분류 삭제
    const removeMid = (event) => {
        setMidEditList(midEditList.filter((item) => item.HIS_LRG_SEQ != Number(event.target.dataset.lrg) || item.HIS_MID_SEQ != Number(event.target.dataset.seq)))
        setSrtEditList(srtEditList.filter((item) => item.HIS_LRG_SEQ != Number(event.target.dataset.lrg) || item.HIS_MID_SEQ != Number(event.target.dataset.seq)));
    }
    // 소분류 삭제
    const removeShort = (event) => {
        setSrtEditList(srtEditList.filter((item) => item.HIS_LRG_SEQ != Number(event.target.dataset.lrg) || item.HIS_MID_SEQ != Number(event.target.dataset.mid) || item.HIS_SRT_SEQ != Number(event.target.dataset.seq)));
    }
    return (
        <>
        <main id="main">
            <section id="breadcrumbs" className="breadcrumbs">
                <div className="container">
                    <ol>
                        <li><a className="gg-font-color">회사소개</a></li>
                        <li>회사연혁</li>
                    </ol>
                    <h2>회사연혁</h2>
                </div>
            </section>
            {admin ? <button className="btn-cancel" onClick={onEditMode}>수정</button> : null}
            <section id="portfolio-details" className="portfolio-details">
                <div className="container">
                    <div className="row gy-12">
                        {loading ? null : (
                            <MDBContainer className="py-5">
                                <MDBRow>
                                {
                                    lrgList.map((lrg) => 
                                        (
                                            <MDBCol key={lrg.HIS_LRG_SEQ} md="6" offsetMd="3">
                                                <h4 className="timeline-h4" style={{ marginLeft: "1.2rem" }}>{lrg.HIS_LRG_NM}</h4>
                                                <ul className="timeline-3">
                                                {
                                                    (midList.filter((m) => m.HIS_LRG_SEQ === lrg.HIS_LRG_SEQ)).map((mid) => {
                                                        return (
                                                            <li key={mid.HIS_MID_NO} >
                                                                <a href="#!">{mid.HIS_MID_NM}</a>
                                                                {
                                                                    (srtList.filter((s) => s.HIS_LRG_SEQ === mid.HIS_LRG_SEQ && s.HIS_MID_SEQ === mid.HIS_MID_SEQ)).map((short) => {
                                                                        return (
                                                                            <p key={short.HIS_SRT_NO} className="mt-2">{short.HIS_SRT_NM}</p>
                                                                        )
                                                                    })
                                                                }
                                                            </li>
                                                        )
                                                    })
                                                }
                                            </ul>
                                            </MDBCol>
                                        )
                                    )
                                }
                                </MDBRow>
                            </MDBContainer>
                            )
                        }
                    </div>
                    <div className="row gy-12" style={{ display: editMode ? 'block' : 'none' }}>
                        {
                            lrgEditList.map((lrg, li) => {
                                let midObjs = (midEditList.filter((m) => m.HIS_LRG_SEQ === lrg.HIS_LRG_SEQ));
                                return (
                                    <Card body key={lrg.HIS_LRG_SEQ}>
                                    <div style={{marginBottom: '50px'}}>
                                        <div style={{marginLeft:'0px'}}>
                                            <label>대분류</label>
                                            <Form.Control
                                                id={`lrg_${lrg.HIS_LRG_SEQ}`}
                                                onChange={changeLrgNm}
                                                type="text"
                                                className="border-primary"
                                                defaultValue={lrg.HIS_LRG_NM}
                                                maxLength={400}
                                            />
                                        </div>
                                    {
                                        midObjs.map((mid, mi) => {
                                            let srtObjs = (srtEditList.filter((s) => s.HIS_LRG_SEQ === mid.HIS_LRG_SEQ && s.HIS_MID_SEQ === mid.HIS_MID_SEQ));
                                            return (
                                                <div key={mid.HIS_MID_NO}>
                                                    <div style={{marginLeft:'15px'}}>
                                                        <label>중분류</label>
                                                        <Form.Control
                                                            id={`mid_${mid.HIS_MID_NO}`}
                                                            onChange={changeMidNm}
                                                            type="text"
                                                            className="border-success"
                                                            defaultValue={mid.HIS_MID_NM}
                                                            maxLength={400}
                                                        />
                                                    </div>
                                                    {
                                                        srtObjs.map((short, si) => {
                                                            return (
                                                                <div key={short.HIS_SRT_NO} style={{marginLeft:'40px'}}>
                                                                    <label>소분류</label>
                                                                    <Form.Control 
                                                                        id={`srt_${short.HIS_SRT_NO}`}
                                                                        onChange={changeShrtNm}
                                                                        type="text"
                                                                        className="border-danger"
                                                                        defaultValue={short.HIS_SRT_NM}
                                                                        maxLength={400}
                                                                    />
                                                                    { srtObjs.length === si+1 ? (
                                                                        <div>
                                                                            <button
                                                                                data-lrg={lrg.HIS_LRG_SEQ}
                                                                                data-mid={mid.HIS_MID_SEQ}
                                                                                data-seq={short.HIS_SRT_SEQ}
                                                                                onClick={appendShrot}
                                                                                className="btn-normal"> 소분류 추가 </button>
                                                                            <button
                                                                                data-lrg={lrg.HIS_LRG_SEQ}
                                                                                data-mid={mid.HIS_MID_SEQ}
                                                                                data-seq={short.HIS_SRT_SEQ}
                                                                                onClick={removeShort}
                                                                                className="btn-delete"
                                                                                disabled={srtObjs.length === 1 ? true : false}> 소분류 삭제 </button>
                                                                        </div>
                                                                    ) : null}
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                    {midObjs.length === mi+1 ? (
                                                        <div>
                                                            <button
                                                                data-lrg={lrg.HIS_LRG_SEQ}
                                                                data-seq={mid.HIS_MID_SEQ}
                                                                onClick={appendMid}
                                                                className="btn-normal"> 중분류 추가 </button>
                                                            <button
                                                                data-lrg={lrg.HIS_LRG_SEQ}
                                                                data-seq={mid.HIS_MID_SEQ}
                                                                onClick={removeMid}
                                                                className="btn-delete"
                                                                disabled={midObjs.length === 1 ? true : false}> 중분류 삭제 </button>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            )
                                        })
                                    }
                                    </div>
                                    {lrgEditList.length === li+1 ? (
                                        <div>
                                            <button
                                                data-seq={lrg.HIS_LRG_SEQ}
                                                onClick={appendLrg}
                                                className="btn-normal"> 대분류 추가 </button>
                                            <button
                                                data-seq={lrg.HIS_LRG_SEQ}
                                                onClick={removeLrg}
                                                className="btn-delete"
                                                disabled={lrgEditList.length === 1 ? true : false}> 대분류 삭제 </button>
                                        </div>
                                    ) : null}
                                </Card>
                                )}
                            )
                        }
                        <button className="btn-normal" onClick={saveHistory} style={{float: 'right'}}>저장</button>
                        <button className="btn-cancel" onClick={offEditMode} style={{float: 'right'}}>닫기</button>
                    </div>
                </div>
            </section>
        </main>
        </>
    );
}
 